<div class="sidesheet mat-elevation-z2">
    <nivelaciones-convenciones [direccion]="'vertical'" [completo]="'false'" [asistencia]="'true'"></nivelaciones-convenciones>
</div>
<!--*ngIf="dataReady"-->

<div style="width: calc(100% - 48px); margin: 48px auto; padding-right: 332px; padding-left: 15px;">
    <h4 class="mat-h2">Nivelaciones por curso</h4>
    <nav-bar [navBarItems]="periodosNavBar" [initialValue]="+periodosNavBar[0].value" [placeholder]="'Seleccione un año'"
        [navOnChange]="true"></nav-bar>
    <div class="grid-header">

        <div class="spacer"></div>
    </div>
    <div *ngIf="dataSource; else loading" class="mat-elevation-z2">
        <mat-table #table [dataSource]="dataSource" matSort>

            <!-- Inicio fila -->
            <ng-container matColumnDef="Curso">
                <mat-header-cell *matHeaderCellDef> Curso</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.nombre}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Registros">
                <mat-header-cell *matHeaderCellDef> Nivelaciones</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <div class="flex-wrap">
                        <div class="inline-flex" style="position: relative">
                            <ng-container *ngIf="element.ausentes !== 0">
                                <div style="position: absolute" class="detalle mat-elevation-z8" #detallesAusente
                                    hidden>
                                    <ul>
                                        <li *ngFor="let detalleAusentes of element.ausentesDetalle">
                                            {{detalleAusentes.alumno}}
                                            <div>
                                                <mat-icon class="md-14">calendar_today</mat-icon>{{detalleAusentes.fechaCorta}}
                                            </div>
                                            <div>
                                                {{detalleAusentes.materia}}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <span class="circulo error cursor-pointer" (click)="toggleDetalles(detallesAusente)">
                                    {{element.ausentes}}
                                </span>
                            </ng-container>
                        </div>
                        <div class="inline-flex" style="position: relative">
                            <ng-container *ngIf="element.retardos !== 0">
                                <div style="position: absolute" class="detalle mat-elevation-z8" #detallesRetardo
                                    hidden>
                                    <ul>
                                        <li *ngFor="let detalleRetardos of element.retardosDetalle">

                                            {{detalleRetardos.alumno}}
                                            <div>
                                                <mat-icon class="md-14">calendar_today</mat-icon>
                                                {{detalleRetardos.fechaCorta}}
                                            </div>
                                            <div>{{detalleRetardos.materia}}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <span class="circulo warn cursor-pointer" (click)="toggleDetalles(detallesRetardo)">
                                    {{element.retardos}}
                                </span>
                            </ng-container>
                        </div>
                        <div class="inline-flex" style="position: relative">
                            <ng-container *ngIf="element.presentes !== 0">
                                <div style="position: absolute" class="detalle mat-elevation-z8" #detallesPresente
                                    hidden>
                                    <ul>
                                        <li *ngFor="let detallePresentes of element.presentesDetalle">

                                            {{detallePresentes.alumno}}
                                            <div>
                                                <mat-icon class="md-14">calendar_today</mat-icon>
                                                {{detallePresentes.fechaCorta}}
                                            </div>
                                            <div>{{detallePresentes.materia}}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <span class="circulo success cursor-pointer" (click)="toggleDetalles(detallesPresente)">
                                    {{element.presentes}}
                                </span>
                            </ng-container>
                        </div>
                        <div class="inline-flex" style="position: relative">
                            <ng-container *ngIf="element.noReportaAsistencia !== 0">
                                <div style="position: absolute" class="detalle mat-elevation-z8" #detallesNoReporta
                                    hidden>
                                    <ul>
                                        <li *ngFor="let detalleNoReporta of element.noReportaAsistenciaDetalle">

                                            {{detalleNoReporta.alumno}}
                                            <div>
                                                <mat-icon class="md-14">calendar_today</mat-icon>
                                                {{detalleNoReporta.fechaCorta}}
                                            </div>
                                            <div> {{detalleNoReporta.materia}}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <span class="circulo neutral cursor-pointer" (click)="toggleDetalles(detallesNoReporta)">
                                    {{element.noReportaAsistencia}}
                                </span>
                            </ng-container>
                        </div>
                        <div class="inline-flex" style="position: relative">
                            <ng-container *ngIf="element.futuras !== 0">
                                <div style="position: absolute" class="detalle mat-elevation-z8" #detallesFuturas
                                    hidden>
                                    <ul>
                                        <li *ngFor="let detalleFuturas of element.futurasDetalle">

                                            {{detalleFuturas.alumno}}
                                            <div>
                                                <mat-icon class="md-14">calendar_today</mat-icon>
                                                {{detalleFuturas.fechaCorta}}
                                            </div>
                                            <div> {{detalleFuturas.materia}}
                                            </div>

                                        </li>
                                    </ul>
                                </div>
                                <span class="circulo cursor-pointer" (click)="toggleDetalles(detallesFuturas)">
                                    {{element.futuras}}
                                </span>
                            </ng-container>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Porcentaje">
                <mat-header-cell *matHeaderCellDef [ngStyle]="{'justify-content':'space-around'}">% Ausencias</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngStyle]="{'justify-content':'space-around'}">{{(element.ausentes/(element.retardos
                    + element.presentes + element.ausentes))*100 |
                    number: '1.0-0'}}%
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Vinculos">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element" [ngStyle]="{'justify-content':'space-around'}">
                    <a [routerLink]="['/nivelaciones/reportes/director-curso/' + element.id]">Ver curso</a>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let element; columns: displayedColumns;">
            </mat-row>
        </mat-table>
    </div>
</div>
<ng-template #loading>
    <mat-spinner [mode]="'indeterminate'"></mat-spinner>
</ng-template>